module.exports = __webpack_public_path__ + "static/media/ce550ac4afce4d2fd49d862db443cabc.ce550ac4.webp";